module.exports = __webpack_public_path__ + "static/media/default.e181eaf3.svg";